import { useContext } from 'react';

import { GuestContext } from 'app/providers/GuestProvider/GuestProvider';

export default function useGuest() {
  return useContext(GuestContext);
}
